import React from 'react'

import Page from '../components/Page'
import BreadcrumbsComponentExtra from '../components/BreadcrumbsComponentExtra'
import ResumeForm from '../components/ResumeForm'

const ResumePage = () => {
  return (
    <Page>
      <h1>Join Our Team!</h1>
      <ResumeForm />
    </Page>
  )
}

export default ResumePage
